import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';
import { AdminAppointmentsModal } from './AdminAppointmentsModal';
import { AppointmentsViewToggle } from './AppointmentsViewToggle';
import {
    APPOINTMENTS_VIEW_PARAM,
    parseAppointmentsView,
    withAppointmentsView,
    type AppointmentsView
} from './appointmentsOverlayParams';
import { VirtualAppointmentsModal } from '../virtual-appointments-overview/VirtualAppointmentsModal';

interface AppointmentsOverlayProps {
    onClose: () => void;
}

// The view lives in the URL (pushed) so it survives a reload and Back returns to the other one.
export function AppointmentsOverlay({ onClose }: AppointmentsOverlayProps) {
    const [searchParams, setSearchParams] = useSearchParams();
    const view = parseAppointmentsView(searchParams.get(APPOINTMENTS_VIEW_PARAM));

    const switchView = useCallback(
        (next: AppointmentsView) => {
            if (next === view) return;
            setSearchParams((prev) => withAppointmentsView(prev, next));
        },
        [view, setSearchParams]
    );

    const viewToggle = <AppointmentsViewToggle value={view} onChange={switchView} />;
    return view === 'virtual' ? (
        <VirtualAppointmentsModal onClose={onClose} viewToggle={viewToggle} />
    ) : (
        <AdminAppointmentsModal onClose={onClose} viewToggle={viewToggle} />
    );
}
